import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M16,22.36a3.52,3.52,0,0,1-2.53-1.05L2.91,10.75l.92-.92L14.39,20.39a2.33,2.33,0,0,0,3.22,0L28.17,9.83l.92.92L18.53,21.31A3.52,3.52,0,0,1,16,22.36Z' })
));